import React, {useState} from 'react';
import CopyIcon from "../../../assets/icons/copy.svg";
import PlusIcon from "../../../assets/icons/plus-small.svg";
import MinusIcon from "../../../assets/icons/minus.svg";
import {HInput, passParamsThrough} from "../../../validation/HForm";
import BasicAlert from "../Alert/Alert";
import {useSelector} from "react-redux";
import CouponHybridRowsTable from './CouponHybridRowsTable/CouponHybridRowsTable';
import { couponType, couponAnnuityType } from '../../../helpers/data-constants';

const emptyRow = {
    startPrice: "",
    endPrice: "",
    basePurity: "",
    delayPurity: "",
    baseThings: "",
    delayThings: "",
    baseCars: "",
    delayAnnuityCars: "",
    baseAnnuityPurity: "",
    delayAnnuityPurity: "",
    baseAnnuityThings: "",
    delayAnnuityThings: "",
    baseAnnuityCars: "",
    delayCars: "",
    startDate: "",
    endDate: ""
}

const CouponRowsTable = ({
                             rows,
                             isPurity,
                             isThings,
                             isCars,
                             onEntityChange,
                             getValues,
                             reset,
                             control,
                             register,
                             errors,
                             isDiscountBirthday,
                             isDiscountBonus,
                             coupon
                         }) => {

    const props = {
        control,
        register,
        errors,
    };
    const [errorAlert, setErrorAlert] = useState('');
    const [stateAlert, setStateAlert] = useState(false);
    const {accessFeatures} = useSelector(({user}) => user);
    const isHybridCoupon = coupon === couponAnnuityType.ANNUITY_HYBRID || coupon === couponType.ANNUITY_HYBRID
    const isAnnuityCoupon = coupon === couponAnnuityType.ANNUITY || coupon === couponType.ANNUITY

    const handleAddAfter = (index) => {
        if (onEntityChange) {
            let values = getValues()
            values.rows.splice(index + 1, 0, emptyRow);
            reset({
                rows: values.rows
            })
            onEntityChange(values.rows);

        }
    }

    const handleRemove = (index) => {
        if (onEntityChange) {
            let values = getValues();
            values.rows.splice(index, 1);
            reset({
                rows: values.rows
            })
            onEntityChange(values.rows);
        }
    }

    const handleCopy = (index) => {
        if (onEntityChange) {
            let values = getValues();
            let rowToCopy = values.rows[index];
            let newRow = accessFeatures["cars.feature"] ? {
                startPrice: rowToCopy.startPrice,
                endPrice: rowToCopy.endPrice,
                basePurity: rowToCopy.basePurity,
                delayPurity: rowToCopy.delayPurity,
                baseThings: rowToCopy.baseThings,
                delayThings: rowToCopy.delayThings,
                baseCars: rowToCopy.baseCars,
                delayCars: rowToCopy.delayCars,
                basePercentBonus: rowToCopy.basePercentBonus,
                basePercentBirthday: rowToCopy.basePercentBirthday,
                baseAnnuityPercentBonus: rowToCopy.baseAnnuityPercentBonus,
                baseAnnuityPercentBirthday: rowToCopy.baseAnnuityPercentBirthday,
                couponRowName: rowToCopy.couponRowName,
                baseAnnuityThings: rowToCopy.baseAnnuityThings,
                delayAnnuityThings: rowToCopy.delayAnnuityThings,
                baseAnnuityPurity: rowToCopy.baseAnnuityPurity,
                delayAnnuityPurity: rowToCopy.delayAnnuityPurity,
                baseAnnuityCars: rowToCopy.baseAnnuityCars,
                delayAnnuityCars: rowToCopy.delayAnnuityCars,
                maxAnnuityDuration: rowToCopy.maxAnnuityDuration,
                minAnnuityDuration: rowToCopy.minAnnuityDuration

            } : {
                startPrice: rowToCopy.startPrice,
                endPrice: rowToCopy.endPrice,
                basePurity: rowToCopy.basePurity,
                delayPurity: rowToCopy.delayPurity,
                baseThings: rowToCopy.baseThings,
                delayThings: rowToCopy.delayThings,
                basePercentBonus: rowToCopy.basePercentBonus,
                basePercentBirthday: rowToCopy.basePercentBirthday,
                couponRowName: rowToCopy.couponRowName
            };
            values.rows.splice(index + 1, 0, newRow);
            reset({
                rows: values.rows
            })
            onEntityChange(values.rows);
        }
    }

    let range = new Array(rows.length)
        .fill(undefined).map((_, i) => i);

    const checkValueInput = (name) => {
        if (name === 'basePercentBonus' && !isDiscountBonus) {
            setErrorAlert('Чек-бокс бонус должен быть активен');
            setStateAlert(true);
        }
        if (name === 'basePercentBirthday' && !isDiscountBirthday) {
            setErrorAlert('Чек-бокс праздничный должен быть активен');
            setStateAlert(true);
        }
    }

    return passParamsThrough(
        <table className="table hover">
            <thead>
            <tr>
                {
                    accessFeatures['coupon.rows.name'] &&
                    <th scope="col">Наименование <br/> диапазона</th>
                }
                <th scope="col">Сумма, BYN</th>
                {
                    accessFeatures['coupons.bonus.enable']
                    && <th scope="col">Бонус</th>
                }
                {
                    accessFeatures['coupons.birthday.enable']
                    && <th scope="col">Праздничный</th>
                }
                {isPurity &&
                    <th scope="col">Базовый д/м</th>
                }
                {isThings &&
                    <th scope="col">Базовый вещи</th>
                }
                {isCars && accessFeatures["cars.feature"] &&
                    <th scope="col">Базовый авто</th>
                }
                {isPurity &&
                    <th scope="col">Неустойка д/м</th>
                }
                {isThings &&
                    <th scope="col">Неустойка вещи</th>
                }
                {isCars && accessFeatures["cars.feature"] &&
                    <th scope="col">Неустойка авто</th>
                }
            </tr>
            </thead>
            {isHybridCoupon ? (
                    <CouponHybridRowsTable 
                        h="true"
                        rows={range}
                        isDiscountBonus={isDiscountBonus} 
                        isDiscountBirthday={isDiscountBirthday}
                        isThings={isThings}
                        isPurity={isPurity}
                        isCars={isCars}
                        checkValueInput={checkValueInput}
                        handleCopy={handleCopy}
                        handleAddAfter={handleAddAfter}
                        handleRemove={handleRemove} />
                ) : (
            <tbody>
            {range.map(number => {
                return (<tr key={number}>
                    {accessFeatures['coupon.rows.name'] &&
                        <th>
                            <div
                                className="form-element-data number">
                                <HInput
                                    h="true"
                                    className="input"
                                    type="text"
                                    name={`rows[${number}].couponRowName`}
                                    id={`name${number}`}
                                />
                            </div>
                        </th>
                    }
                    <th scope="row">
                        <span className="caption">Сумма, BYN</span>
                        <div className="table-cellcontent">
                            <div className="form-row">
                                <div className="form-row-item">
                                    <div
                                        className="form-element">
                                        <div
                                            className="form-element-data number">
                                            <HInput
                                                h="true"
                                                className="input"
                                                type="text"
                                                name={`rows[${number}].startPrice`}
                                                id={`startPrice${number}`}
                                                decimals={2}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row-item">
                                    <div className="form-element">
                                        <div className="form-element-data">
                                            <div className="form-element-data-text">
                                                <p>—</p></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row-item">
                                    <div
                                        className="form-element">
                                        <div
                                            className="form-element-data number">
                                            <HInput
                                                h="true"
                                                className="input"
                                                type="text"
                                                name={`rows[${number}].endPrice`}
                                                id={`endPrice${number}`}
                                                decimals={2}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </th>
                    {
                        accessFeatures['coupons.bonus.enable'] && <th>
                        <div className="form-element">
                            <div className="form-element-data number">
                                <HInput
                                    h="true"
                                    className="input"
                                    type="text"
                                    name={`rows[${number}].${isAnnuityCoupon ? 'baseAnnuityPercentBonus' : 'basePercentBonus'}`}
                                    id="basePercentBonus"
                                    decimals={2}
                                    readOnly={!isDiscountBonus}
                                    onClick={() => checkValueInput('basePercentBonus')}
                                />
                            </div>
                        </div>
                    </th>
                    }
                    {
                        accessFeatures['coupons.birthday.enable'] &&
                        <th>
                        <div className="form-element">
                            <div className="form-element-data number">
                                <HInput
                                    h="true"
                                    className="input"
                                    type="text"
                                    name={`rows[${number}].${isAnnuityCoupon ? 'baseAnnuityPercentBirthday' : 'basePercentBirthday'}`}
                                    id="basePercentBirthday"
                                    readOnly={!isDiscountBirthday}
                                    decimals={2}
                                    onClick={() => checkValueInput('basePercentBirthday')}
                                />
                            </div>
                        </div>
                    </th>
                    }
                    {isPurity &&
                        <td>
                            <span className="caption">Базовый д/м</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].basePurity`}
                                            id={`basePurity${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    {isThings &&
                        <td>
                            <span className="caption">Базовый вещи</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].baseThings`}
                                            id={`baseThings${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    {isCars && accessFeatures["cars.feature"] &&
                        <td>
                            <span className="caption">Базовый авто</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].baseCars`}
                                            id={`baseCars${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    {isPurity &&
                        <td>
                            <span className="caption">Просрочка д/м</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].delayPurity`}
                                            id={`delayPurity${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    {isThings &&
                        <td>
                            <span className="caption">Просрочка вещи</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].delayThings`}
                                            id={`delayThings${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    {isCars && accessFeatures["cars.feature"] &&
                        <td>
                            <span className="caption">Просрочка авто</span>
                            <div className="table-cellcontent">
                                <div className="form-element">
                                    <div
                                        className="form-element-data number">
                                        <HInput
                                            h="true"
                                            className="input"
                                            type="text"
                                            name={`rows[${number}].delayCars`}
                                            id={`delayCars${number}`}
                                            decimals={2}/>
                                    </div>
                                </div>
                            </div>
                        </td>}
                    <td>
                        <div className="table-cell-actions">
                            <button className="button-icontrigger" type={"button"}
                                    onClick={() => handleCopy(number)}>
                  <span className="icon">
                    <CopyIcon/>
                  </span>
                            </button>
                            <button className="button-icontrigger" type={"button"}
                                    onClick={() => handleAddAfter(number)}>
                  <span className="icon">
                    <PlusIcon/>
                  </span>
                            </button>
                            {!(rows.length === 1) &&
                                <button className="button-icontrigger" type={"button"}
                                        onClick={() => handleRemove(number)}>
                  <span className="icon">
                    <MinusIcon/>
                  </span>
                                </button>
                            }
                        </div>
                    </td>
                </tr>)
            })}
            </tbody>)}
            <BasicAlert onClose={() => setStateAlert(false)}
                        message={errorAlert}
                        isOpen={stateAlert}
                        isError={true}/>
        </table>, props);
}

export default CouponRowsTable;
